/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, threshold: NonNullable<unknown>, dimensions: NonNullable<unknown> }} Crisp_Bright_Wolf_FawnInputs */

const en_crisp_bright_wolf_fawn = /** @type {(inputs: Crisp_Bright_Wolf_FawnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hidden (${i?.count}/${i?.threshold} responses, caused by ${i?.dimensions})`)
};

const de_crisp_bright_wolf_fawn = /** @type {(inputs: Crisp_Bright_Wolf_FawnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verborgen (${i?.count}/${i?.threshold} Antworten, verursacht durch ${i?.dimensions})`)
};

/**
* | output |
* | --- |
* | "Hidden ({count}/{threshold} responses, caused by {dimensions})" |
*
* @param {Crisp_Bright_Wolf_FawnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const crisp_bright_wolf_fawn = /** @type {((inputs: Crisp_Bright_Wolf_FawnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crisp_Bright_Wolf_FawnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crisp_bright_wolf_fawn(inputs)
	return de_crisp_bright_wolf_fawn(inputs)
});